import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Container,
  Grid,
  styled,
} from "@mui/material";

import { getEmployeeProfile } from "../../../../../actions/employee";

import LeftPanel from "./left";
import RightPanel from "./right";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
});

const EmployeeProfilePage = (props) => {
  const dispatch = useDispatch();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  let { idEmployees } = useParams();


  useEffect(() => {
    if (userProfile) {
      dispatch(getEmployeeProfile(idEmployees, "manager"));
    }
  }, [userProfile]);

  return (
    <StyledRoot className={`page`}>
      {/* <StyledCover /> */}
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <LeftPanel />
          </Grid>
          <Grid item xs={12} sm={8}>
            <RightPanel />
          </Grid>
        </Grid>
      </Container>
    </StyledRoot>
  );
};

export default EmployeeProfilePage;
